import axios from "axios";

export default {
    getPiliangConfig() {
        return axios.get("/course/Sale/getPiliangConfig");
    },
    getPiliangPrice(obj) {
        return axios.post("/course/Sale/getPiliangPrice", obj);
    },
    createPiliang(obj) {
        return axios.post("/course/Sale/createPiliang", obj);
    },
    getMyPiliang() {
        return axios.get("/course/Sale/getMyPiliang");
    },
    getPiliangCode(obj) {
        return axios.post("/course/Sale/getPiliangCode", obj);
    },

}